import { createFileRoute, Outlet } from '@tanstack/react-router'

/**
 * Guest-facing surface. Nothing here touches the session — guests arrive with
 * a signed link, never an account. Kept as its own layout so no planner chrome
 * or authenticated query can leak into it.
 */
export const Route = createFileRoute('/_public')({
  component: () => (
    <div className="page-stagger-scope min-h-dvh">
      <Outlet />
    </div>
  ),
})
